import React from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import branding from '../../styles/branding';

const CardsControlButtons = ({ hasEntries, onCreateDashboard, isSavingCards = false, isEditingMode = false }) => {
    const disabledStyle = {
        ...branding.button.style,
        backgroundColor: '#d3d3d3',
        color: '#a9a9a9',
        cursor: 'not-allowed',
    };

    return (
        <Box className="cards-control-buttons">
            <Button
                {...branding.button}
                className="cards-create-dashboard-button"
                disabled={!hasEntries || isSavingCards}
                onClick={onCreateDashboard}
                startIcon={isSavingCards ? <CircularProgress size={20} /> : null}
                style={(!hasEntries || isSavingCards) ? disabledStyle : branding.button.style}
            >
                {isSavingCards
                  ? (isEditingMode ? 'Updating Dashboard...' : 'Creating Dashboard...')
                  : (isEditingMode ? 'Update Dashboard' : 'Create Dashboard')}
            </Button>
        </Box>
    );
};

export default CardsControlButtons;
